import { Box } from 'components/ui/Box'
import { Icon } from 'components/ui/Icon'
import Link from 'next/link'
import { FC } from 'react'
import { useTheme } from 'styled-components'

import { BreadcrumbLink, ScrollWrapper, Wrapper } from './styles'

interface BreadcrumbsLink {
  url: string
  label: string
}

interface Props {
  links: Array<BreadcrumbsLink>
  mobileScrollable?: boolean
}

export const Breadcrumbs: FC<Props> = ({ links, mobileScrollable = false }) => {
  const theme = useTheme()

  return (
    <ScrollWrapper mobileScrollable={mobileScrollable}>
      <Wrapper mobileScrollable={mobileScrollable}>
        {links.map(link => (
          <BreadcrumbLink key={link.url + link.label}>
            <Link href={link.url}>
              <a>{link.label}</a>
            </Link>
            <Box marginLeft={8}>
              <Icon
                className='icon'
                color={theme.palette.core.DEEP_GRAY}
                icon={theme.icons.core.BreadcrumbsArrow}
              />
            </Box>
          </BreadcrumbLink>
        ))}
      </Wrapper>
    </ScrollWrapper>
  )
}
